import { TInfrastructureItem, TTAInfrastructureItem } from '../../../../types/map';

export function getDateText(infrastructureItem: TInfrastructureItem | TTAInfrastructureItem): string | undefined {
  if ('constructionDateText' in infrastructureItem) {
    return infrastructureItem.constructionDateText;
  }

  return undefined;
}
